import BaseAPI from 'utils/api/base';

import type {
  BundleResponse,
  CreateRecordResponse,
  CreateTrainingRecordPayload,
  TrainingRecordsResponse,
} from './trainingRecords.types';

const TRAINING_RECORDS_TIMEOUT = 60_000;

class TrainingRecordsAPI extends BaseAPI {
  loadRecords = async (contactEmail: string): Promise<TrainingRecordsResponse> => {
    const { data } = await this.request<TrainingRecordsResponse>({
      url: '/training-records/',
      method: 'GET',
      params: { contact_email: contactEmail },
      timeout: TRAINING_RECORDS_TIMEOUT,
    })();
    return data;
  };

  createRecord = async (payload: CreateTrainingRecordPayload): Promise<CreateRecordResponse> => {
    const body: Record<string, unknown> = {
      contact_email: payload.contactEmail,
      module_name: payload.moduleName,
    };
    if (payload.isExempt !== undefined) body.is_exempt = payload.isExempt;
    if (payload.courseDate !== undefined) body.course_date = payload.courseDate;
    if (payload.expiryDate !== undefined) body.expiry_date = payload.expiryDate;
    if (payload.passFail !== undefined) body.pass_fail = payload.passFail;
    if (payload.status !== undefined) body.status = payload.status;
    if (payload.location !== undefined) body.location = payload.location;
    if (payload.instructor !== undefined) body.instructor = payload.instructor;
    if (payload.certificateFile !== undefined) body.certificate_file = payload.certificateFile;
    if (payload.certificateFilename !== undefined) body.certificate_filename = payload.certificateFilename;

    const { data } = await this.request<CreateRecordResponse>({
      url: '/training-records/',
      method: 'POST',
      data: body,
      timeout: TRAINING_RECORDS_TIMEOUT,
    })();
    return data;
  };

  bundleCertificates = async (contactEmail: string, contactName?: string): Promise<BundleResponse> => {
    const body: Record<string, unknown> = {
      contact_email: contactEmail,
      compliance_status: 'compliant',
    };
    if (contactName) body.contact_name = contactName;

    const { data } = await this.request<BundleResponse>({
      url: '/training-records/bundle/',
      method: 'POST',
      data: body,
      timeout: TRAINING_RECORDS_TIMEOUT,
    })();
    return data;
  };

  openCertificate = (recordId: number | string): void => {
    this.open({
      url: `/api/training-records/${encodeURIComponent(String(recordId))}/certificate/`,
    })();
  };
}

export default TrainingRecordsAPI;
